export const sidebarResizerId = 'layout-sidebar-resizer';
export const sidebarRightResizerId = 'layout-sidebar-resizer';
